// extracted by mini-css-extract-plugin
export default {"inputStyles":"styles_inputStyles__hMEgn","labelStyles":"styles_labelStyles__GB6Dl","profileContainer":"styles_profileContainer__IC3x0"};